import React, { useState } from 'react';
import { Helmet } from 'react-helmet';

const DesignSystem = () => {
  const canonicalUrl = `${process.env.REACT_APP_BASE_URL}/design-system`;
  const [activeItem, setActiveItem] = useState('services');

  return (
    <section id="design-system">
      <Helmet>
        <link rel="canonical" href={canonicalUrl} />
      </Helmet>
      <div className="design-system">
        <h2 className="page-title">Design System</h2>
        <p>Menu preview:</p>
        <nav className="design-menu" aria-label="Design system menu preview">
          <a
            href="/services"
            className={`design-menu-link font-bold${activeItem === 'services' ? ' is-active' : ''}`}
            onClick={(event) => {
              event.preventDefault();
              setActiveItem('services');
            }}
          >
            Services
          </a>
          <a
            href="/about"
            className={`design-menu-link font-bold${activeItem === 'about' ? ' is-active' : ''}`}
            onClick={(event) => {
              event.preventDefault();
              setActiveItem('about');
            }}
          >
            About
          </a>
          <a
            href="/contact"
            className={`design-menu-link font-bold${activeItem === 'contact' ? ' is-active' : ''}`}
            onClick={(event) => {
              event.preventDefault();
              setActiveItem('contact');
            }}
          >
            Contact
          </a>
        </nav>
        <p>Font weight check (same size):</p>
        <div className="font-weight-check">
          <span className="font-regular">BonVivant Regular</span>
          <span className="font-bold">BonVivant Bold</span>
        </div>
        <p>Page title header scale preview:</p>
        <h1>Heading 1</h1>
        <h2>Heading 2</h2>
        <h3>Heading 3</h3>
        <h4>Heading 4</h4>
        <h5>Heading 5</h5>
        <h6>Heading 6</h6>
      </div>
    </section>
  );
};

export default DesignSystem;
